import React from "react";
import {
  Box,
  Stack,
  Typography,
  LinearProgress,
  IconButton,
} from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  name: string;
  size?: number; // bytes
  progress: number; // 0 - 100
  onRemove: () => void;
};

const formatBytes = (bytes: number) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const UploadFileItem: React.FC<Props> = ({
  name,
  size,
  progress,
  onRemove,
}) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{
        width: "100%",
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        p: 2,
      }}
    >
      <InsertDriveFileOutlinedIcon fontSize="large" />

      <Box flex={1}>
        <Typography variant="body2">{name}</Typography>
        {size && (
          <Typography variant="caption" color="text.secondary">
            {formatBytes(size)}
          </Typography>
        )}
        {progress < 100 && (
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{ mt: 1, height: 6, borderRadius: 3 }}
          />
        )}
      </Box>

      {/* ✅ X button */}
      <IconButton size="small" onClick={onRemove} sx={{ ml: "auto" }}>
        <CloseIcon />
      </IconButton>
    </Stack>
  );
};

export default UploadFileItem;
